import EditIcon from "@material-ui/icons/Edit";
import Button from "@mui/material/Button";
import React from "react";
import strings from "../../config/localization";

interface Props {
  onClickHandler?: () => void;
  label?: string;
}

export default function EditButton({
  onClickHandler = () => {},
  label = strings.edit,
}: Props) {
  return (
    <Button
      variant="outlined"
      size="small"
      startIcon={<EditIcon />}
      onClick={onClickHandler}
    >
      {label}
    </Button>
  );
}
